<template>
    <v-container>
        <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-basic
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogo"
                            :src="imageFrontURL">
                    </clipper-basic>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="getCutingLogo()"
                    >{{$t('recortar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2>{{$t('configuracion')}}</h2>
        <br>
        <v-layout align-center justify-center fill-height>
        </v-layout>
        <br>
        <v-layout  align-center justify-center fill-height>
        </v-layout>
        <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12 sm6>
                <v-layout align-center justify-center fill-height>
                    <v-card  height="450" width="500" align="center">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('cambiar_contrasena')}}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <form class="mt-7" @submit.prevent="changePassword()">
                                <v-text-field
                                        autocomplete="username"
                                        v-model="currentPassword"
                                        name="currentPassword"
                                        prepend-icon="mdi-lock"
                                        :label="$t('current_password')"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="show = !show"
                                        :error-messages="errores.current_password"
                                ></v-text-field>
                                <ValidationObserver v-slot="{ invalid }" ref="observer">
                                    <ValidationProvider :rules="'required|password:@confirm'" v-slot="{ errors }">
                                        <v-text-field
                                                autocomplete="new-password"
                                                v-model="password"
                                                name="password"
                                                prepend-icon="mdi-lock"
                                                :label="$t('new_password')"
                                                :type="show ? 'text' : 'password'"
                                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="show = !show"
                                                :error-messages="errors[0] ? errors[0] : errores.new_password"
                                        ></v-text-field>
                                    </ValidationProvider>
                                    <ValidationProvider name="confirm" :rules="'required'" v-slot="{ errors }">
                                        <v-text-field
                                                autocomplete="new-password"
                                                v-model="confirmedPassword"
                                                name="confirmedPassword"
                                                prepend-icon="mdi-lock"
                                                :type="show ? 'text' : 'password'"
                                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="show = !show"
                                                :label="$t('password_new_confirm')"
                                                :error-messages="errors[0]"
                                        ></v-text-field>
                                    </ValidationProvider>
                                    <br>
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            :loading="loadingPassword"
                                            :disabled="invalid"
                                    >
                                        {{$t('modificar')}}
                                    </v-btn>
                                </ValidationObserver>
                            </form>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-flex>
            <v-flex v-if="profileData.role === 1" xs12 sm6>
                <v-layout align-center justify-center fill-height>
                    <v-card width="500" height="450" align="center">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('cambiar_wallpaper')}}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <form @submit.prevent="changeWallpaper()">
                                <br>
                                <v-flex xs12 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultLogoURL"
                                            v-if="resultLogoURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialogImageLogo = true"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores.wallpaper"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.wallpaper}}
                                    </v-alert>
                                </v-flex>
                                <br>
                                <v-btn
                                        :disabled="resultLogoURL === null || resultLogoURL.length < 500"
                                        color="primary"
                                        :loading="loadingWallpaper"
                                        type="submit"
                                >
                                    {{$t('modificar')}}
                                </v-btn>
                            </form>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-flex>
            <v-flex v-if="profileData.role === 2 || profileData.role === 3" xs12 sm6>
                <v-layout align-center justify-center fill-height>
                    <v-card width="500" height="450" align="center">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title class="text-center">
                                {{ $t('msg_mi_codigo')}}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <form @submit.prevent="downloadMyAccessCode()">
                                <br>
                                <v-flex xs12>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="'https://api.qrserver.com/v1/create-qr-code/?data=' + profileData.access_code + '&ecc=M&margin=20&size=400x400'"
                                            width="250"
                                            height="250"
                                    ></v-img>
                                </v-flex>
                                <br>
                                <v-btn
                                        color="primary"
                                        :loading="loadingWallpaper"
                                        type="submit"
                                >
                                    {{$t('descargar')}}
                                </v-btn>
                            </form>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-flex>
        </v-layout>
        <br>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xs12 sm6>
          <v-layout align-center justify-center fill-height>
            <v-card width="300" align="center">
              <v-toolbar dark color="primary">
                <v-toolbar-title>
                  {{ $t('notificaciones')}}
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form @submit.prevent="changeNotifications()">
                  <v-switch
                      v-model="canSMS"
                      :label="$t('canSendSMS')">

                  </v-switch>
                  <v-switch
                      v-model="canEmail"
                      :label="$t('canSendEmail')">

                  </v-switch>
                  <br>
                  <v-btn
                      color="primary"
                      type="submit"
                      :loading="loadingNotification"
                  >
                    {{$t('modificar')}}
                  </v-btn>
                </form>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-flex>
        <v-flex v-if="profileData.role === 2" xs12 sm6>
          <v-layout align-center justify-center fill-height>
            <v-card width="350" align="center">
              <v-toolbar dark color="primary">
                <v-toolbar-title>
                  {{ $t('vacation_mode')}}
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form @submit.prevent="changeVacationMode()">
                  <v-checkbox
                      v-model="vacation_mode"
                      :label="$t('activar')">
                  </v-checkbox>
                  <v-layout row wrap>
                    <v-flex sm6>
                      <v-menu
                          v-model="menuCalendar"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model="computedDateFormatted"
                              :label="$t('fecha_inicial')"
                              outlined
                              :disabled="!vacation_mode"
                              hint="DD/MM/YYYY"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              :error-messages="errores.vacation_mode_initial_date"
                              readonly
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date"
                            no-title
                            :min="getCurrentDate()"
                            :locale="$t('region')"
                            @input="menuCalendar = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex sm6>
                      <v-menu
                          v-model="menuCalendarExpiration"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model="computedDateExpirationFormatted"
                              :label="$t('finish_date')"
                              outlined
                              :disabled="!vacation_mode"
                              hint="DD/MM/YYYY"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              :error-messages="errores.vacation_mode_final_date"
                              readonly
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateExpiration"
                            no-title
                            :min="getCurrentDate()"
                            :locale="$t('region')"
                            @input="menuCalendarExpiration = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-switch
                      v-model="allow_access_visitors"
                      :label="$t('allow_access_visitors')"
                      :disabled="!vacation_mode"
                  >
                  </v-switch>
                  <v-switch
                      v-model="allow_access_residents"
                      :label="$t('allow_access_residents')"
                      :disabled="!vacation_mode"
                  >
                  </v-switch>
                  <v-switch
                      v-model="allow_access_workers"
                      :label="$t('allow_access_workers')"
                      :disabled="!vacation_mode"
                  >

                  </v-switch>
                  <v-btn
                      color="primary"
                      type="submit"
                      :loading="loadingVacationMode"
                  >
                    {{$t('modificar')}}
                  </v-btn>
                </form>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-flex>
        <v-flex v-if="profileData.role === 1" xs12 sm6>
          <v-layout align-center justify-center fill-height>
            <v-card width="350" align="center">
              <v-toolbar dark color="primary">
                <v-toolbar-title>
                  {{ $t('rulebook')}}
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form @submit.prevent="changeRulebook()">
                  <br>
                  <v-file-input
                          v-model="file"
                          :rules="rules"
                          chips
                          show-size
                          accept=".pdf"
                          :placeholder="$t('selecciona_archivo_pdf')"
                          :label="$t('archivo')"
                          :error-messages="errores.file"
                  ></v-file-input>
                  <v-btn
                      color="primary"
                      type="submit"
                      :loading="loadingRulebook"
                      :disabled="(file === null) || (file === file_aux) ? true : false"
                  >
                     {{file_aux === null ? $t('agregar') : $t('modificar')}}
                  </v-btn>
                </form>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import Vue from 'vue'
import VuejsClipper from 'vuejs-clipper'
import JSPDF from 'jspdf'
import { mapGetters, mapState } from 'vuex'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'settings',
  data: () => ({
    currentPassword: '',
    password: '',
    confirmedPassword: '',
    errores: [],
    show: false,
    profileData: {},
    canSMS: null,
    canEmail: null,
    vacation_mode: null,
    allow_access_visitors: null,
    allow_access_residents: null,
    allow_access_workers: null,
    loadingPassword: false,
    loadingNotification: false,
    loadingRulebook: false,
    loadingVacationMode: false,
    dialogImageLogo: false,
    imageFrontURL: '',
    resultLogoURL: '',
    menuCalendar: false,
    dateExpiration: '',
    menuCalendarExpiration: false,
    date: '',
    file: null,
    file_aux: null,
    rules: [
      value => !!value || 'Archivo requerido.'
    ],
    loadingWallpaper: false
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDateExpirationFormatted () {
      return this.formatDate(this.dateExpiration)
    },
    ...mapState(['language']),
    ...mapGetters(['getProfile'])
  },
  created () {
    this.getProfileData()
    this.getRulebook()
  },
  methods: {
    getCurrentDate () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    changePassword () {
      this.errores = []
      this.loadingPassword = true
      const config = {
        method: 'PATCH',
        url: 'https://clubtest.intrare.app/users/restore_password/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          current_password: this.currentPassword,
          new_password: this.password
        }
      }
      axios(config)
        .then(ok => {
          this.loadingPassword = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_cambio_password'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingPassword = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data.non_field_errors) {
              this.errores.new_password = []
              for (var i = 0; i < error.response.data.non_field_errors.length; i++) {
                this.errores.new_password += error.response.data.non_field_errors[i]
              }
            } else {
              this.errores = error.response.data
            }
          }
        })
    },
    clear () {
      this.$refs.observer.reset()
      this.cleanFields()
      this.errores = []
      this.$store.commit('snackbar_activate_false')
    },
    cleanFields () {
      this.currentPassword = ''
      this.password = ''
      this.confirmedPassword = ''
    },
    getProfileData () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/users/me/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.profileData = response.data
          this.resultLogoURL = response.data.wallpaper
          this.canSMS = this.profileData.can_sms
          this.canEmail = this.profileData.can_email
          this.vacation_mode = this.profileData.vacation_mode
          this.allow_access_visitors = this.profileData.allow_access_visitors
          this.allow_access_residents = this.profileData.allow_access_residents
          this.allow_access_workers = this.profileData.allow_access_workers
          this.date = this.profileData.vacation_mode_initial_date
          this.dateExpiration = this.profileData.vacation_mode_final_date
        })
        .catch(error => {
          console.log(error)
        })
    },
    getRulebook () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/housing_unit/rulebook/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          console.log(response.data[0].rulebook)
          if (response.data[0].rulebook !== null) {
            var fileAux = new File(['foo'], response.data[0].rulebook)
            this.file = fileAux
            this.file_aux = fileAux
          } else {
            this.file = null
            this.file_aux = null
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeNotifications () {
      this.loadingNotification = true
      const config = {
        method: 'PATCH',
        url: 'https://clubtest.intrare.app/auth/users/' + this.profileData.id + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          'can_sms': this.canSMS,
          'can_email': this.canEmail
        }
      }
      axios(config)
        .then(ok => {
          this.loadingNotification = false
          this.getProfileData()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('notificacion_success'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingNotification = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    changeRulebook () {
      this.loadingRulebook = true
      var bodyFormData = new FormData()

      bodyFormData.append('rulebook', this.file)

      const config = {
        method: 'PATCH',
        url: 'https://clubtest.intrare.app/housing_unit/update/rulebook/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loadingRulebook = false
          this.getRulebook()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('rulebook_uploaded_successfully'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingRulebook = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    changeVacationMode () {
      this.errores = []
      this.loadingVacationMode = true
      let config = {}
      if (this.vacation_mode === true) {
        config = {
          method: 'PATCH',
          url: 'https://clubtest.intrare.app/auth/users/' + this.profileData.id + '/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: {
            'vacation_mode': this.vacation_mode,
            'allow_access_visitors': this.allow_access_visitors,
            'allow_access_residents': this.allow_access_residents,
            'allow_access_workers': this.allow_access_workers,
            'vacation_mode_initial_date': this.date,
            'vacation_mode_final_date': this.dateExpiration
          }
        }
      } else {
        config = {
          method: 'PATCH',
          url: 'https://clubtest.intrare.app/auth/users/' + this.profileData.id + '/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: {
            'vacation_mode': this.vacation_mode,
            'allow_access_visitors': this.allow_access_visitors,
            'allow_access_residents': this.allow_access_residents,
            'allow_access_workers': this.allow_access_workers
          }
        }
      }
      axios(config)
        .then(ok => {
          this.loadingVacationMode = false
          this.getProfileData()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('notificacion_success'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingVacationMode = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getCutingLogo () {
      // console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log(this.resultLogoURL)
      this.dialogImageLogo = false
    },
    changeWallpaper () {
      this.errores = []
      this.loadingWallpaper = true
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()
      if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
        fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'wallpaper_update' + newID + '.jpeg')
      }
      bodyFormData.append('wallpaper', fileImageFront)
      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/housing_unit/update/wallpaper/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          console.log(ok)
          this.loadingWallpaper = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('cambiar_wallpaper_exito'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingWallpaper = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    dataURLtoFile (dataurl, filename) {
      console.log('Tamaño Imagen = ' + dataurl.length + ' caracteres.')
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    xOffset: function (pdf, text) {
      return (
        pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2)
    },
    getImgFromUrl (logoUrl, callback) {
      var img = new Image()

      img.src = logoUrl
      img.onload = function () {
        callback(img)
      }
    },
    downloadMyAccessCode () {
      this.loadingWallpaper = true
      var urlAvatarAux = this.profileData.avatar
      var urlLogotipoAux = this.profileData.logo
      const toDataUrl = (url, callback) => {
        const xhr = new XMLHttpRequest()
        xhr.onload = () => {
          const reader = new FileReader()
          reader.onloadend = () => {
            callback(reader.result)
          }
          reader.readAsDataURL(xhr.response)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
      }
      toDataUrl('https://api.qrserver.com/v1/create-qr-code/?data=' + this.profileData.access_code + '&ecc=M&margin=20&size=400x400', (qrCodeImage) => {
        var pdf = new JSPDF('portrait', 'pt', 'letter')
        // Black square with rounded corners
        pdf.setDrawColor(0)
        pdf.setFillColor(255, 255, 255)
        pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
        // pdf.setFontStyle('bold')
        // pdf.text(infoInvitationSend.housing_unit_name,
        //   this.xOffset(pdf, infoInvitationSend.housing_unit_name),
        //   100)
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('residente'),
          this.xOffset(pdf, this.$t('residente')),
          115)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(this.profileData.first_name + ' ' + this.profileData.last_name,
          this.xOffset(pdf, this.profileData.first_name + ' ' + this.profileData.last_name),
          130)
        // pdf.setFontStyle('normal')
        // pdf.setFontSize(16)
        // pdf.text(this.$t('Anfitrion'),
        //   this.xOffset(pdf, this.$t('Anfitrion')),
        //   145)
        // pdf.setFontStyle('bold')
        // pdf.setFontSize(13)
        // pdf.text(infoInvitationSend.host_name,
        //   this.xOffset(pdf, infoInvitationSend.host_name),
        //   160)
        // pdf.setFontStyle('normal')
        // pdf.setFontSize(16)
        // pdf.text(this.$t('numero_casa'),
        //   this.xOffset(pdf, this.$t('numero_casa')),
        //   175)
        // pdf.setTextColor('#000000')
        // pdf.setFontStyle('bold')
        // pdf.setFontSize(13)
        // pdf.text(infoInvitationSend.house_address,
        //   this.xOffset(pdf, infoInvitationSend.house_address),
        //   190)
        // pdf.setTextColor('#000000')
        // pdf.setFontStyle('normal')
        // pdf.setFontSize(16)
        // pdf.text(this.$t('fecha_hora'),
        //   this.xOffset(pdf, this.$t('fecha_hora')),
        //   205)
        // pdf.setFontStyle('bold')
        // pdf.setFontSize(13)
        // pdf.text(infoInvitationSend.date + ' ' + infoInvitationSend.hour,
        //   this.xOffset(pdf, infoInvitationSend.date + ' ' + infoInvitationSend.hour),
        //   220)
        // pdf.setTextColor('#000000')
        // pdf.setFontStyle('normal')
        // pdf.setFontSize(16)
        // pdf.text(this.$t('fecha_expiracion'),
        //   this.xOffset(pdf, this.$t('fecha_expiracion')),
        //   235)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(this.$t('msg_mi_codigo'),
          this.xOffset(pdf, this.$t('msg_mi_codigo')),
          250)
        pdf.setFontSize(6)
        pdf.setFontStyle('normal')
        pdf.text('El único objetivo del presente gafete es la de validar el acceso del portador',
          this.xOffset(pdf, 'El único objetivo del presente gafete es la de validar el acceso del portador'),
          410)
        pdf.text('mediante las reglas de operación del sistema Intrare Residencia. No existe',
          this.xOffset(pdf, 'mediante las reglas de operación del sistema Intrare Residencia. No existe'),
          418)
        pdf.text('relación laboral alguna entre el portador de este gafete ni con la empresa',
          this.xOffset(pdf, 'relación laboral alguna entre el portador de este gafete ni con la empresa'),
          426)
        pdf.text('Intrare Residencia ni con el Fraccionamiento.',
          this.xOffset(pdf, 'Intrare Residencia ni con el Fraccionamiento.'),
          434)
        // pdf.setLineWidth(4.0)
        // pdf.setDrawColor('#0000FF')
        // pdf.setFillColor('#FFFFFF')
        // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
        // console.log(qrCodeImage); // qrCodeImage is the base64 string
        pdf.addImage(qrCodeImage, 'WEBP', 230, 254, 150, 150)
        toDataUrl(urlLogotipoAux, (logoGuest) => {
          pdf.addImage(logoGuest, 'WEBP', 190, 60, 50, 50)
          this.getImgFromUrl(require('../assets/residencial_mx.png'), function (logoSystem) {
            pdf.addImage(logoSystem, 'WEBP', 370, 60, 50, 50)
            toDataUrl(urlAvatarAux, (avatar) => {
              pdf.addImage(avatar, 'WEBP', 265, 150, 80, 80)
              pdf.save('gafete.pdf')
            })
          })
        })
        this.loadingWallpaper = false
      })
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #2a2738 #2a2738 #2a2738 #2a2738;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
